module.exports = __webpack_public_path__ + "img/BOWTIE 1 RED.1295aaf.svg";